import {
    INIT_REGISTRO_CITA,  
    REGISTRO_CITA_EXITOSO,
    REGISTRO_CITA_ERROR,
    OBTENER_SUCURSALES_SUCCESS,
    OBTENER_SUCURSALES_ERROR,
    OBTENER_ESTUDIOS_SUCCESS,
    OBTENER_ESTUDIOS_ERROR,
    OBTENER_CITAS,      
    OBTENER_CITAS_EXITOSO,
    OBTENER_CITAS_ERROR 
} from '../../types';

export default (state, action) => {
    switch(action.type) {
        case OBTENER_CITAS:
        case INIT_REGISTRO_CITA:
            return {
                ...state,
                cargando: true,
                requests: state.requests + 1
            };
        case OBTENER_CITAS_EXITOSO:
        case REGISTRO_CITA_EXITOSO:
            return {
                ...state,
                cargando: false,
                requests: state.requests - 1,
                citas: action.payload
            };
        case OBTENER_CITAS_ERROR:
        case REGISTRO_CITA_ERROR:
            return {
                ...state,
                cargando: false,
                requests: state.requests - 1,
                citas: null,
                error: action.payload
            };
        case OBTENER_SUCURSALES_SUCCESS:
            return {
                ...state,
                cargando: false,
                sucursales: action.payload
            };
        case OBTENER_SUCURSALES_ERROR:
            return {
                ...state,
                cargando: false,
                sucursales: [],
                error: action.payload
            };
        case OBTENER_ESTUDIOS_SUCCESS:
            return {
                ...state,
                cargando: false,
                estudios: action.payload
            };
        case OBTENER_ESTUDIOS_ERROR:
            return {
                ...state,
                cargando: false,
                estudios: [],
                error: action.payload
            }; 
        default:
            return state;
    }
}